/**
 * Theme Configuration
 * Single source of truth for all themes
 */

export const THEME_CONFIG = {
  classic: '',           // Base files with no suffix (hero-home.tsx)
  aman: '.aman',         // Aman Hotels variant files (hero-home.aman.tsx)
  barelux: '.barelux',   // Bare Lux Studio variant files (hero-home.barelux.tsx)
  balance: '.balance',   // Balance Aesthetics variant files (hero-home.balance.tsx)
  custom: '',            // Fully custom sites — no design-system CSS loaded, all styling built in the site itself
} as const;

export type Theme = keyof typeof THEME_CONFIG;

export function getAvailableThemes(): Theme[] {
  return Object.keys(THEME_CONFIG) as Theme[];
}

export function getThemeSuffix(theme: Theme): string {
  return THEME_CONFIG[theme] || '';
}

export function isValidTheme(theme: string): theme is Theme {
  return theme in THEME_CONFIG;
}
